import React from "react";
import Stake from "../components/Stake";
import Header from "../layout/Header/header";

const Staking = () => {
  return (
    <div className="stake-pg">
      <Header />
      <Stake />
    </div>
  );
};

export default Staking;
